const CrossSellSkeleton = ({ displayImage = true }) => {
  return (
    <div
      className="addon-container grid gap-2 grid-flow-row grid-cols-[3fr_1fr]"
      aria-busy="true"
      aria-label="Loading cross-sell option"
    >
      <div className="col-span-2 animate-pulse border-2 border-white">
        <div className="grid grid-cols-[2rem_1fr_auto] items-center gap-2 bg-white p-3 border-2 border-white">
          <div className="size-8 shrink-0 rounded-full bg-sand-light" />
          <div className="flex flex-col gap-2 self-center">
            <div className="h-4 w-[min(280px,80%)] rounded bg-sand-light" />
            <div className="h-3 w-14 rounded bg-sand-light/80" />
          </div>
          {displayImage && (
            <div className="size-[80px] shrink-0 bg-sand-light" />
          )}
        </div>
      </div>
      <div className="h-10 animate-pulse border-2 border-white bg-white py-2" />
      <div className="min-h-10 min-w-max animate-pulse bg-white p-2" />
    </div>
  );
};

export default CrossSellSkeleton;
